import { render, staticRenderFns } from "./Xiaoxidetails.vue?vue&type=template&id=66be14f6&scoped=true"
import script from "./Xiaoxidetails.vue?vue&type=script&lang=js"
export * from "./Xiaoxidetails.vue?vue&type=script&lang=js"
import style0 from "./Xiaoxidetails.vue?vue&type=style&index=0&id=66be14f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66be14f6",
  null
  
)

export default component.exports